import { useQuery } from 'react-query';
import BattlesService from 'services/battles/BattlesService';

export type UseGetMyBattlePlayerStatusProps = {
	'services.battlesService': BattlesService;
};

export const useGetMyBattlePlayerStatus = (props: UseGetMyBattlePlayerStatusProps) => {
	const battlesService = props['services.battlesService'];

	return useQuery({
		queryKey: ['battles-my-battle-status'],
		queryFn: () => battlesService.fetchMyStatus(),
	});
};

export default useGetMyBattlePlayerStatus;
